function storageUnavailableError(error: unknown): Error {
  const details = error instanceof Error ? error.message : String(error);
  return new Error(
    `Browser storage is unavailable, so this action cannot safely continue. ${details}`
  );
}

export function safeLocalStorageGet(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeLocalStorageSet(key: string, value: string): boolean {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function safeLocalStorageRemove(key: string): boolean {
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export function requireLocalStorageSet(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    throw storageUnavailableError(error);
  }
}
